module.exports = __webpack_public_path__ + "static/media/Footer.b7ea79d7.jpg";